import { Application } from '@raydiant/api-client-js';
import ApplicationGroup from './ApplicationGroup';
import config from '../../../config';

export interface ApplicationsLayoutProps {
  applications: Application[] | undefined;
  isLoading: boolean;
  selectedFilterGroup: string;
  onClick: (application: Application) => void;
  onDefaultMarketplaceCardClick: () => void;
}

const { publicAssetUrl } = config;

const ApplicationsLayout = ({
  applications,
  isLoading,
  selectedFilterGroup,
  onClick,
  onDefaultMarketplaceCardClick,
}: ApplicationsLayoutProps) => {
  if (isLoading) {
    return (
      <div className="flex flex-1 min-h-[270px] md:min-h-[300px] justify-center items-center">
        <div className="relative w-24 h-24">
          <div className="absolute inset-0 border-4 border-gray-200 border-t-primary-600 rounded-full animate-spin" />
          <img
            className="absolute inset-0 m-auto w-10 h-10"
            src={`${publicAssetUrl}/brand/logo-icon-primary.svg`}
            alt="Logo"
          />
        </div>
      </div>
    );
  }
  return (
    <>
      {(selectedFilterGroup === 'all' || selectedFilterGroup === 'content') && (
        <ApplicationGroup
          data={applications}
          onClick={onClick}
          groupName="content"
          onDefaultMarketplaceCardClick={onDefaultMarketplaceCardClick}
        />
      )}

      {(selectedFilterGroup === 'all' || selectedFilterGroup === 'menu') && (
        <ApplicationGroup
          data={applications}
          onClick={onClick}
          groupName="menu"
          onDefaultMarketplaceCardClick={onDefaultMarketplaceCardClick}
        />
      )}

      {(selectedFilterGroup === 'all' ||
        selectedFilterGroup === 'communication') && (
        <ApplicationGroup
          data={applications}
          onClick={onClick}
          groupName="communication"
          onDefaultMarketplaceCardClick={onDefaultMarketplaceCardClick}
        />
      )}
    </>
  );
};

export default ApplicationsLayout;
